import { $http, Constants } from '@/store/actions/constants';

const url = `${Constants.BaseURL}/dashboard`;

export const dashboardAction = {
    dashboard({ commit, state }) {
        return $http.get(url, state.authHeader).then(res => {
            if (res.status === 200 && res.data) {
                let dd = {
                    me: {},
                    company: {},
                    calendar: false,
                    activities: {
                        anniversary: null,
                        everything: null,
                        holidays: null,
                        time_off: null,
                    },
                    announcements: [],
                    todos: [],
                    benefits: [],
                    my_time_offs: [],
                    available_timeoffs: [],
                };

                dd.me = res.data.me;
                dd.company = res.data.company; // todo : check if we need this
                dd.calendar = res.data.calendar ? res.data.calendar : false;
                dd.todos = res.data.todos;
                dd.activities = res.data.activities;
                dd.announcements = res.data.announcements;
                dd.benefits = res.data.benefits;
                dd.my_time_offs = res.data.my_time_offs;
                dd.available_timeoffs = res.data.available_timeoffs;

                if (res.data.my_time_offs) {
                    commit('SET_MY_TIMEOFFS', res.data.my_time_offs);
                }
                if (res.data.available_timeoffs) {
                    commit('SET_AVAILABLE_TIMEOFFS', res.data.available_timeoffs);
                }
                commit('SET_DASHBOARD', dd);
                commit('EMP_POP_SHOW');
            }
        });
    }
};
